<template>
  <BaseVisualBanner
    v-if="hasResourcePriceBanner"
    :heading="small ? '' : $t(`${type}.adding_extra`)"
    :description="innerText"
    :primaryAction="
      learnMoreLink
        ? {
            text: $t('global.learn_more'),
            href: link
          }
        : undefined
    "
    imagePath="/img/onboarding/employee_info.svg"
    size="s"
    color="blue"
    v-test="'resource-price'"
  />
</template>

<script lang="ts">
import { mapState } from 'pinia';
import { computed, defineComponent } from 'vue';
import filters from '@/filters';
import { brandName } from '@/helpers/brand-name';
import { helpCenterArticleUrl } from '@/helpers/help-center';
import { useCompanyStore } from '@/stores/company';

export default defineComponent({
  props: {
    type: {
      type: String,
    },
    small: {
      type: Boolean,
      default: false,
    },
    learnMoreLink: {
      type: Boolean,
      default: false,
    },
    mt: {
      type: Number,
      default: 0,
    },
    mb: {
      type: Number,
      default: 0,
    },
  },
  setup(props) {
    const { company } = useCompanyStore();
    const hasResourcePriceBanner = computed(
      () =>
        !(
          props.type === 'resource' &&
          (company.activeSubscription?.plan === 'pro' ||
            company.activeSubscription?.plan === 'prolight')
        ) && company.activeSubscription?.plan !== 'lite',
    );

    return {
      filters,
      hasResourcePriceBanner,
    };
  },
  computed: {
    ...mapState(useCompanyStore, ['company', 'isTrial']),
    innerText() {
      return this.$t(`${this.type}.trial_charge_info`, brandName());
    },
    link() {
      return helpCenterArticleUrl(572113);
    },
  },
});
</script>

<style
  lang="scss"
  module
>
.image {
  margin-top: $spacing * -2;

  &:not(.small) {
    width: 150px;
  }

  &.small {
    width: 100px;
  }
}
</style>
